import { render, staticRenderFns } from "./SelectMenu.vue?vue&type=template&id=2600c31a&scoped=true"
import script from "./SelectMenu.vue?vue&type=script&lang=js"
export * from "./SelectMenu.vue?vue&type=script&lang=js"
import style0 from "./SelectMenu.vue?vue&type=style&index=0&id=2600c31a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600c31a",
  null
  
)

export default component.exports